import { render, staticRenderFns } from "./ResearchInfoCard.vue?vue&type=template&id=28ff69ca&"
import script from "./ResearchInfoCard.vue?vue&type=script&lang=js&"
export * from "./ResearchInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports